'use client';

import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';

export default function useHasConnectedWalletBefore() {
	return useSyncLocalStorage('hasConnectedWalletBefore', false);
}
